// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Administrators compare workspace spending and policy in the same
 * visual frame used by Jobs and Metrics. This route supplies the full-height
 * administration background and one content container, while the costs
 * subsystem supplies the data cards; duplicating either wrapper would break
 * alignment between those related operational dashboards.
 */
import { CostsComponent } from '@/subsystems/costs';
import { useAuth } from '@/subsystems/workspaces';
import { apiClient } from "@/app-shell/api/api-client";

export default function Costs() {
  const { selectedOrganizationId, selectedWorkspaceId, isGlobalAdmin, isWorkspaceAdmin } = useAuth();

  // Don't render the costs component until we have a workspace selected and API instance
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-gray-600">
              Please select a workspace to view costs.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full bg-slate-50">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <CostsComponent
          app_id="docreview"
          api_instance={apiClient.getAxiosInstance()}
          organization_id={selectedOrganizationId}
          workspace_id={selectedWorkspaceId}
          default_cost_view="workspace"
          is_admin={isGlobalAdmin}
          can_manage_workspace_costs={isGlobalAdmin || isWorkspaceAdmin}
        />
      </div>
    </div>
  );
}
